var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBubbleInfo = function SvgBubbleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333.5H1.666C.933.5.34 1.1.34 1.833l-.007 12L3 11.167h9.333c.733 0 1.333-.6 1.333-1.334v-8c0-.733-.6-1.333-1.333-1.333m-6 2.667h1.333V4.5H6.333zm0 2.666h1.333V8.5H6.333z"
  })));
};
export default SvgBubbleInfo;